var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"d-flex align-items-center justify-content-center h-100 background",style:(_vm.backgroundStyle),attrs:{"id":"BreakTheWall"}})
}
var staticRenderFns = []

export { render, staticRenderFns }